// dotMD Lineal Metres Handler - Front End Product Page UX

function setupLinealMetreTool(context = document) {
  const unitSelector = context.querySelector('[data-lineal-selector]');
  const linealInput = context.querySelector('[data-lineal-input]');
  const quantityInput = context.querySelector('[data-quantity-input]');
  const variantLengthSelector = context.querySelector('select[data-variant-option-index="0"]');
  const quantityWrapper = context.querySelector('.quantity-selector__wrapper');
  const linealInputWrapper = context.querySelector('[data-lineal-input-wrapper]');
  const note = context.querySelector('[data-lineal-note]');
  const addToCartBtn = context.querySelector('button[type="submit"]');

  const unitTypeProp = context.querySelector('#unit-type-property');
  const linealMetreProp = context.querySelector('#total-metres-property');

  if (!unitSelector || !linealInput || !quantityInput || !variantLengthSelector || !quantityWrapper || !linealInputWrapper || !addToCartBtn) return;

  // --- Error Message Block ---
  const errorMsg = document.createElement('div');
  errorMsg.textContent = "Please enter a valid lineal metre value.";
  errorMsg.style.color = "#D32F2F";
  errorMsg.style.marginTop = "0.5rem";
  errorMsg.style.fontSize = "0.9rem";
  errorMsg.style.display = "none";
  linealInputWrapper.appendChild(errorMsg);

  // --- Input Validator ---
  function validateLinealInput() {
    if (unitSelector.value === 'lineal metre') {
      const val = parseFloat(linealInput.value);
      if (isNaN(val) || val <= 0) {
        addToCartBtn.disabled = true;
        addToCartBtn.classList.add('disabled');
        return false;
      }
    }
    addToCartBtn.disabled = false;
    addToCartBtn.classList.remove('disabled');
    return true;
  }

  const getStickLength = () => {
    const selected = variantLengthSelector.querySelector('option:checked');
    return selected ? parseFloat(selected.textContent) : NaN;
  };

  const updateQuantityFromMetres = () => {
    const stickLength = getStickLength();
    const raw = parseFloat(linealInput.dataset.raw || linealInput.value);

    if (!isNaN(stickLength) && !isNaN(raw) && stickLength > 0) {
      const sticks = Math.ceil(raw / stickLength);
      const rounded = sticks * stickLength;

      quantityInput.value = sticks;
      linealInput.value = rounded.toFixed(2);
      if (note) note.textContent = `= ${sticks} stick(s) of ${stickLength}m`;

      // Updated logic to pass total LM to hidden field
      if (linealMetreProp) {
        const totalMetres = sticks * stickLength;
        linealMetreProp.value = totalMetres.toFixed(2);
      }
    } else {
      if (note) note.textContent = '';
      if (linealMetreProp) linealMetreProp.value = '';
    }
  };

  const setDefaultLinealMetres = () => {
    const stickLength = getStickLength();
    if (!isNaN(stickLength) && stickLength > 0) {
      const defaultMetres = stickLength;
      linealInput.dataset.raw = defaultMetres;
      linealInput.value = defaultMetres.toFixed(2);
      updateQuantityFromMetres();
  
      // Ensure floating label moves correctly
      linealInput.classList.add('form-field-filled');
    }
  };

  const activateLinealMode = () => {
    linealInputWrapper.style.display = 'block';
    quantityWrapper.classList.add('disabled');
    if (unitTypeProp) unitTypeProp.value = 'Lineal Metre';
    setDefaultLinealMetres();
    validateLinealInput();
  };

  const deactivateLinealMode = () => {
    linealInputWrapper.style.display = 'none';
    quantityWrapper.classList.remove('disabled');
    if (note) note.textContent = '';
    if (unitTypeProp) unitTypeProp.value = 'Stick';
    if (linealMetreProp) linealMetreProp.value = '';
    errorMsg.style.display = "none";
    addToCartBtn.disabled = false;
    addToCartBtn.classList.remove('disabled');
  };

  let debounce;
  linealInput.addEventListener('input', () => {
    const raw = linealInput.value.trim();

    if (raw === '') {
      linealInput.dataset.raw = '';
      updateQuantityFromMetres();
      validateLinealInput();
      return;
    }

    clearTimeout(debounce);
    debounce = setTimeout(() => {
      linealInput.dataset.raw = raw;
      updateQuantityFromMetres();
      validateLinealInput();
    }, 1500);
  });

  const updateMetresFromQuantity = () => {
    const stickLength = getStickLength();
    const qty = parseInt(quantityInput.value);

    if (!isNaN(qty) && !isNaN(stickLength)) {
      const lm = qty * stickLength;
      linealInput.dataset.raw = lm;
      linealInput.value = lm.toFixed(2);
      if (note) note.textContent = `= ${qty} stick(s) of ${stickLength}m`;
      if (linealMetreProp) linealMetreProp.value = lm.toFixed(2);
    }
  };

  // Manual typing is still covered
  quantityInput.addEventListener('input', updateMetresFromQuantity);

  // Interval watcher to catch Shopify +/– button changes
  let lastQty = quantityInput.value;
  setInterval(() => {
    const currentQty = quantityInput.value;
    if (currentQty !== lastQty) {
      lastQty = currentQty;
      updateMetresFromQuantity();
    }
  }, 200);

  unitSelector.addEventListener('change', () => {
    if (unitSelector.value === 'lineal metre') {
      activateLinealMode();
    } else {
      deactivateLinealMode();
    }
    validateLinealInput();
  });

  variantLengthSelector.addEventListener('change', () => {
    if (unitSelector.value === 'lineal metre') {
      setDefaultLinealMetres();
      setTimeout(() => {
        validateLinealInput();
      }, 100);
    }
  });

  context.addEventListener('submit', (e) => {
    if (!validateLinealInput()) {
      e.preventDefault();
      e.stopPropagation();
      errorMsg.style.display = "block";
    } else {
      errorMsg.style.display = "none";
    }
  });

  // Initialise on load
  unitSelector.value = 'lineal metre';
  unitSelector.dispatchEvent(new Event('change'));
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('form[data-product-form]').forEach(form => {
    if (!form.dataset.lmSetup) {
      setupLinealMetreTool(form);
      form.dataset.lmSetup = 'true';
    }
  });
});

new MutationObserver(() => {
  setTimeout(() => {
    document.querySelectorAll('form[data-product-form]').forEach(form => {
      if (!form.dataset.lmSetup) {
        setupLinealMetreTool(form);
        form.dataset.lmSetup = 'true';
      }
    });
  }, 200);
}).observe(document.body, { childList: true, subtree: true });
